module.exports = __webpack_public_path__ + "img/appose.232d555c.png";